import React from 'react';
import {Routes} from "./routes";
import {AppProviders} from "./app-providers";

import 'theme/main.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'rc-drawer/assets/index.css';

function App() {
    return (
        <AppProviders>
            <Routes/>
        </AppProviders>
    );
}

export default App;
